import { deviationSign, formatSignedEuro, formatSignedPercent } from "../lib/format";

/** A price deviation: red "+" costs more, green "−" saves; always euro and percent together. */
export default function SignedDeviation({
  amount,
  percent,
  layout = "stacked",
}: {
  amount: string | number | null | undefined;
  percent?: string | number | null;
  layout?: "stacked" | "inline";
}) {
  const sign = deviationSign(amount ?? percent);
  if (formatSignedEuro(amount) === "–" && formatSignedPercent(percent) === "–") {
    return <span className="text-slate-400">–</span>;
  }
  const tone = sign === "+" ? "text-rose-700" : sign === "−" ? "text-emerald-700" : "text-slate-700";
  return (
    <span className={`inline-flex max-w-full font-medium tabular-nums ${layout === "inline" ? "flex-wrap items-baseline justify-end gap-x-1.5 gap-y-0.5" : "flex-col items-end"} ${tone}`}>
      <span className="min-w-0 max-w-full [overflow-wrap:anywhere]">{formatSignedEuro(amount)}</span>
      {percent !== undefined ? (
        <span className={`max-w-full [overflow-wrap:anywhere] font-normal ${layout === "inline" ? "text-xs opacity-80" : "text-[11px]"}`}>{layout === "inline" ? `(${formatSignedPercent(percent)})` : formatSignedPercent(percent)}</span>
      ) : null}
    </span>
  );
}
